module.exports = __webpack_public_path__ + "img/alignment_select.334b2743.svg";